var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOnlyWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24mm",
    height: "24mm",
    viewBox: "0 0 24.000001 24",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-1{fill:#eb4b47;}"))), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "translate(-9.536743e-7,-0.0253334)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.50334
    },
    id: "path14",
    cx: -12.000001,
    cy: 12.025333,
    r: 12,
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1.4821676,0,0,1.4821676,-105.28811,-207.56629)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 74.437875,146.20346 a 0.67733332,0.67733332 0 1 0 0.677333,0.67733 0.67733332,0.67733332 0 0 0 -0.677333,-0.67733 z",
    id: "path1",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 74.437875,149.30702 a 0.67733332,0.67733332 0 1 0 0.677333,0.67734 0.67733332,0.67733332 0 0 0 -0.677333,-0.67734 z",
    id: "path2",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 74.437875,143.0999 a 0.67733332,0.67733332 0 1 0 0.677333,0.67733 0.67733332,0.67733332 0 0 0 -0.677333,-0.67733 z",
    id: "path3",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 77.552021,144.45192 a 0.67733332,0.67733332 0 1 0 -0.677333,-0.67469 0.67468749,0.67468749 0 0 0 0.677333,0.67469 z",
    id: "path4",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 80.663521,144.45192 a 0.67733332,0.67733332 0 1 0 -0.677333,-0.67469 0.67468749,0.67468749 0 0 0 0.677333,0.67469 z",
    id: "path5",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 77.552017,
    cy: 142.02304,
    r: 0.33602083,
    id: "circle5",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 80.663521,
    cy: 142.02304,
    r: 0.33602083,
    id: "circle6",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 77.552021,154.50344 a 0.33602083,0.33602083 0 1 0 0.336021,0.33602 0.33602083,0.33602083 0 0 0 -0.336021,-0.33602 z",
    id: "path6",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 80.663521,154.50344 a 0.33602083,0.33602083 0 1 0 0.336021,0.33602 0.33602083,0.33602083 0 0 0 -0.336021,-0.33602 z",
    id: "path7",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.699562,
    cy: 149.987,
    r: 0.33602083,
    id: "circle7",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 72.699563,146.53948 a 0.33602083,0.33602083 0 1 0 0.33602,0.33602 0.33602083,0.33602083 0 0 0 -0.33602,-0.33602 z",
    id: "path8",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 85.521271,149.65098 a 0.33602083,0.33602083 0 1 0 0.336021,0.33602 0.33602083,0.33602083 0 0 0 -0.336021,-0.33602 z",
    id: "path9",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 85.521271,146.53948 a 0.33602083,0.33602083 0 1 0 0.336021,0.33602 0.33602083,0.33602083 0 0 0 -0.336021,-0.33602 z",
    id: "path10",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 83.775021,143.0999 a 0.67733332,0.67733332 0 1 0 0.687916,0.67733 0.67733332,0.67733332 0 0 0 -0.687916,-0.67733 z",
    id: "path11",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 83.775021,146.20346 a 0.67733332,0.67733332 0 1 0 0.687916,0.67733 0.67733332,0.67733332 0 0 0 -0.687916,-0.67733 z",
    id: "path12",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 83.775021,149.30702 a 0.67733332,0.67733332 0 1 0 0.687916,0.67734 0.67733332,0.67733332 0 0 0 -0.687916,-0.67734 z",
    id: "path13",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.00325,
    cy: 161.33669,
    r: 1.17475,
    transform: "rotate(-13.279999)",
    id: "circle13",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: -48.992195,
    cy: 158.45154,
    r: 1.17475,
    transform: "rotate(-45)",
    id: "circle14",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: -48.985107,
    cy: 163.33855,
    r: 1.17475,
    transform: "rotate(-45)",
    id: "circle15",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40.840908,
    cy: 163.90085,
    r: 1.17475,
    transform: "rotate(-13.279999)",
    id: "circle16",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 74.437875,152.40794 a 0.67733332,0.67733332 0 1 0 0.677333,0.67733 0.67733332,0.67733332 0 0 0 -0.677333,-0.67733 z",
    id: "path16",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 77.552021,152.40794 a 0.67733332,0.67733332 0 1 0 0.674687,0.67733 0.67733332,0.67733332 0 0 0 -0.674687,-0.67733 z",
    id: "path17",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 80.663521,152.40794 a 0.67733332,0.67733332 0 1 0 0.674687,0.67733 0.67733332,0.67733332 0 0 0 -0.674687,-0.67733 z",
    id: "path18",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 83.775021,152.40794 a 0.67733332,0.67733332 0 1 0 0.687916,0.67998 0.67733332,0.67733332 0 0 0 -0.687916,-0.67998 z",
    id: "path19",
    style: {
      fill: "#eb4b47",
      strokeWidth: 0.264583
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyWithBg);
export default __webpack_public_path__ + "static/media/logoOnlyWithBG.cc19f3accf3977c2cec9c6b2fffa8022.svg";
export { ForwardRef as ReactComponent };